import { BeratungChange } from '@o30/entities';
import { Comparator } from '../comparator';
import { compareInkasso } from './inkasso-comparator';

/*,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-^"-.,.-"^"-.,.-"^"-.,.-"^*
|       /\                                                                       /\       |
|      /  \                this is a generated file, do not edit                /  \      |
|      |  |                                                                     |  |      |
|      |  |                see comparator.info for entity version               |  |      |
|     / == \               by ComparatorGenerator (O30 Entities)               / == \     |
|     |/**\|                                                                   |/**\|     |
\*,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-^"-.,.-"^"-.,.-"^"-.,.-"*/

export const compareBeratungChange: (backup: BeratungChange, data: BeratungChange) => { [P in keyof BeratungChange]?: BeratungChange[P] } = (backup, data) => {
  let key: keyof BeratungChange;
  const diff: Partial<BeratungChange> = {};
  const comparator = new BeratungChangeComparator();

  key = 'inkasso';
  comparator.addDiff(diff, key,
    compareInkasso(backup ? backup[key] : null, data ? data[key] : null));

  return comparator.compare(backup, data, diff);
};

export class BeratungChangeComparator extends Comparator<BeratungChange> {
  public static readonly IDS: (keyof BeratungChange)[] = [];
  public static readonly PROPERTIES: (keyof BeratungChange)[] = [];
  public static readonly FIELDPROPERTIES: (keyof BeratungChange)[] = [
    'ablaufdatum',
    'beginndatum',
    'versicherungsbestaetigung'
  ];
  public static readonly KEYVALUEFIELDPROPERTIES: (keyof BeratungChange)[] = [];
  public static readonly KEYVALUELISTFIELDPROPERTIES: (keyof BeratungChange)[] = [];
  public static readonly OBJECTPROPERTIES: (keyof BeratungChange)[] = [
    'inkasso'
  ];
  public static readonly IGNOREDPROPERTIES: (keyof BeratungChange)[] = [];

  /**
   * makes sure all properties are handled by the comparator
   * if there is an error, you might need to re-run ComparatorGenerator
   */
  public getTestMock(): BeratungChange {
    return {
      ablaufdatum:               null,
      beginndatum:               null,
      inkasso:                   null,
      versicherungsbestaetigung: null
    };
  }

  public getIds() {
    return BeratungChangeComparator.IDS;
  }

  public getProperties() {
    return BeratungChangeComparator.PROPERTIES;
  }

  public getFieldProperties() {
    return BeratungChangeComparator.FIELDPROPERTIES;
  }

  public getKeyValueFieldProperties() {
    return BeratungChangeComparator.KEYVALUEFIELDPROPERTIES;
  }

  public getKeyValueListFieldProperties() {
    return BeratungChangeComparator.KEYVALUELISTFIELDPROPERTIES;
  }

  public getObjectProperties() {
    return BeratungChangeComparator.OBJECTPROPERTIES;
  }

  public getIgnoredProperties() {
    return BeratungChangeComparator.IGNOREDPROPERTIES;
  }

}
